"use client";
import * as React from "react";
const SvgSentimentSatisfiedRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.8 7.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m-5.6 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4m3.53-4.89a.6.6 0 0 0-.83.2A3.2 3.2 0 0 1 8 11.2a3.2 3.2 0 0 1-2.7-1.5.6.6 0 1 0-1.02.63A4.4 4.4 0 0 0 8 12.4a4.4 4.4 0 0 0 3.72-2.06.6.6 0 0 0-.2-.83" }));
export {
  SvgSentimentSatisfiedRound as default
};
